import {
    Button,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@mui/material';
import React, { useState } from 'react';
import { BOOLEAN_TYPES } from '../../../configs/constants';
import { useSnackbar } from 'notistack';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export default function ProgramDetailForm({
    isEdit,
    initialData,
    setInitialData,
    // currentData,
    currentIndex,
    allProgramType,
    errors,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInitialData((currentInitialArray) => {
            const clonedData = structuredClone(currentInitialArray);
            clonedData[currentIndex][name] = value;

            return clonedData;
        });
    };


  const MAX_FILE_SIZE_MB = 2; // Maximum file size in megabytes
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // Convert to bytes

const handleImageInsert = (e) => {
    const uploadedFiles = e.target.files;

    if (uploadedFiles && uploadedFiles.length > 0 && uploadedFiles[0].size > MAX_FILE_SIZE_BYTES) {
        // Display an alert with the error message
        alert(`Таны оруулсан зураг ${MAX_FILE_SIZE_MB}MB-аас хэтэрсэн байна.`);

        // Reset the image data in the state
        setInitialData((currentInitialArray) => {
            const clonedData = structuredClone(currentInitialArray);
            clonedData[currentIndex]['image'] = null;
            clonedData[currentIndex]['imgUrl'] = null;

            return clonedData;
        });
    } else if (uploadedFiles && uploadedFiles.length > 0) {
        const reader = new FileReader();
        reader.onloadend = () => {
            setInitialData((currentInitialArray) => {
                const clonedData = structuredClone(currentInitialArray);
                clonedData[currentIndex]['image'] = uploadedFiles[0];
                clonedData[currentIndex]['imgUrl'] = reader.result;

                return clonedData;
            });
        };

        reader.readAsDataURL(uploadedFiles[0]);
    }
};

    return (
        <>
            <form style={{ width: '80%', display: 'inline-block' }}>
                <Grid
                    container
                    direction="column"
                    spacing={2}
                    sx={{ width: '100%', margin: 0 }}
                >
                    <Grid
                        item
                        container
                        spacing={2}
                        direction="column"
                        sx={{
                            boxShadow: '0 0 34px 9px rgba(0,0,0,.05)',
                            padding: '20px 0',
                            margin: 0,
                        }}
                    >
                        <Grid item>
                            <span
                                style={{
                                    display: 'inline-block',
                                    margin: '8px 35px 8px 0px',
                                }}
                            >
                                <TextField
                                    id="program-detail-date"
                                    label="Хөтөлбөрийн өдөр"
                                    type="date"
                                    name='broadcastDate'
                                    value={ initialData[currentIndex].broadcastDate}
                                    sx={{ width: 220 }}
                                    InputLabelProps={{
                                    shrink: true,
                                    required: true, 
                                        style: {
                                            color: '#ec7063', 
                                        },
                                    }}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.broadcastDate)}
                                    helperText={errors.broadcastTime}
                                    required
                                />
                            </span>
                            <span
                                style={{
                                    display: 'inline-block',
                                    margin: '8px 35px 8px 0px',
                                }}
                            >

                                <TextField
                                    id="program-detail-time"
                                    label="Хөтөлбөрийн цаг"
                                    type="time"
                                    name="broadcastTime"
                                    value={initialData[currentIndex].broadcastTime}
                                    InputLabelProps={{
                                        shrink: true,
                                        required: true, 
                                            style: {
                                                color: '#ec7063', 
                                            },
                                        }}
                                    inputProps={{
                                        step: 300, // 5 min
                                    }}
                                    sx={{ width: 150 }}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.broadcastTime)}
                                    helperText={errors.broadcastTime}
                                    required
                                    
                                />
                            </span>
                            <FormControl sx={{ m: 1, width: '300px' }}>
                                <InputLabel id="program-type-select">
                                    Хөтөлбөрийн төрөл
                                </InputLabel>
                                <Select
                                    labelId="program-type-select"
                                    value={
                                        initialData[currentIndex].programTypeId
                                    }
                                    onChange={handleInputChange}
                                    label="Хөтөлбөрийн төрөл"
                                    name="programTypeId"
                                    MenuProps={MenuProps}
                                    error={Boolean(
                                        errors[currentIndex].programTypeId,
                                    )}
                                >
                                    <MenuItem value="">
                                        <em style={{ fontStyle: 'normal' }}>
                                            Хөтөлбөрийн төрөл
                                        </em>
                                    </MenuItem>
                                    {allProgramType.map((programType) => (
                                        <MenuItem
                                            key={programType.id}
                                            value={programType.id}
                                        >
                                            {programType.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {Boolean(errors.programTypeId) && (
                                    <FormHelperText
                                        style={{ color: '#d32f2f' }}
                                    >
                                        {errors[currentIndex].programTypeId}
                                    </FormHelperText>
                                )}
                            </FormControl>
                            {/* </span> */}

                            <TextField
                                sx={{ width: '50%', marginRight: '15px' }}
                                value={initialData[currentIndex].duration}
                                variant="standard"
                                label="Хөтөлбөрийн үргэлжлэх хугацаа"
                                fullWidth
                                name="duration"
                                onChange={handleInputChange}
                                error={Boolean(errors.duration)}
                                helperText={errors.broadcastTime}
                                required
                                InputLabelProps={{
                                    shrink: true,
                                    required: true, 
                                    style: {
                                        color: '#ec7063', 
                                    },
                                }}
                            />

                            <FormControl sx={{ m: 1, width: '300px' }}>
                                <InputLabel id="program-repeat">
                                    Давтагдах эсэх
                                </InputLabel>
                                <Select
                                    labelId="program-repeat"
                                    value={initialData[currentIndex].isRepeat}
                                    onChange={handleInputChange}
                                    label="Давтагдах эсэх"
                                    name="isRepeat"
                                    MenuProps={MenuProps}
                                    error={Boolean(errors.isRepeat)}
                                >
                                    <MenuItem value="">
                                        <em style={{ fontStyle: 'normal' }}>
                                            Давтагдах эсэх
                                        </em>
                                    </MenuItem>
                                    {BOOLEAN_TYPES.map((type) => (
                                        <MenuItem
                                            key={type.type}
                                            value={type.type}
                                        >
                                            {type.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <TextField
                                sx={{ width: '50%', marginRight: '15px' }}
                                value={initialData[currentIndex].name}
                                variant="standard"
                                label="Хөтөлбөрийн Нэр"
                                fullWidth
                                name="name"
                                onChange={handleInputChange}
                                error={Boolean(errors.name)}
                                helperText={errors.broadcastTime}
                                required
                                InputLabelProps={{
                                    shrink: true,
                                    required: true, 
                                    style: {
                                        color: '#ec7063', 
                                    },
                                }}
                                    
                            />
                            <TextField
                                sx={{ width: '45%' }}
                                value={initialData[currentIndex].description}
                                variant="standard"
                                label="Тайлбар"
                                fullWidth
                                name="description"
                                onChange={handleInputChange}
                                error={Boolean(errors.description)}
                                helperText={errors[currentIndex].description}
                            />
                        </Grid>
                        <Grid item container direction="column" gap="20px">
                            <div>
                                {initialData[currentIndex].imgUrl && (
                                    <img
                                        src={initialData[currentIndex].imgUrl}
                                        style={{
                                            height: '300px',
                                            width: '400px',
                                            objectFit: 'cover',
                                        }}
                                    />
                                )}
                            </div>
                            {/* {errors.image ? (
                            <InputErrorMessage errorMessage={errors.image} />
                        ) : null} */}
                            <div>
                                <p style={{ fontSize: '12px' }}>
                                    Зургийн харьцаа 4:3 (800x600), зургийн
                                    хэмжээ дээд 2mb
                                </p>
                                <Button variant="contained" component="label">
                                    <input
                                        hidden
                                        accept="image/*"
                                        type="file"
                                        onChange={handleImageInsert}
                                    />
                                    Thumbnail зураг оруулах
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </>
    );
}
